<template>
    <v-list dense nav>
        <v-list-item :to="{ path: '/' }">
            <v-list-item-icon>
                <v-icon color="black">mdi-home</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
                <v-list-item-title class="black--text"
                    >Inicio</v-list-item-title
                >
            </v-list-item-content>
        </v-list-item>

        <template v-if="$route.path !== '/login'">
            <v-list-group
                @click="
                    () => {
                        if (item.path != null && item.path != '') {
                            $router.push(item.path);
                        }
                    }
                "
                v-for="item in items"
                :key="item.text"
                :class="item.hijo == true ? '' : 'listIcon'"
            >
                <template v-slot:activator>
                    <router-link
                        :to="item.path"
                        class="link"
                        style="width: 100%; display: flex"
                    >
                        <v-list-item-icon>
                            <v-icon color="black">{{ item.icon }}</v-icon>
                        </v-list-item-icon>

                        <v-list-item-title
                            v-text="item.text"
                            style="z-index: 10000 !important"
                        ></v-list-item-title>
                    </router-link>
                </template>
                <router-link
                    :to="child.path"
                    v-for="child in item.children"
                    :key="child.text"
                >
                    <v-list-group
                        :sub-group="child.hijo"
                        :key="child.text"
                        :class="child.hijo == true ? '' : 'listIcon'"
                    >
                        <template v-slot:activator>
                            <v-list-item-icon style="margin-left: 1rem">
                                <v-icon color="black">{{ child.icon }}</v-icon>
                            </v-list-item-icon>

                            <v-list-item-title
                                v-text="child.text"
                                style="z-index: 10000 !important"
                            ></v-list-item-title>
                        </template>
                        <router-link
                            :to="child_1.path"
                            v-for="child_1 in child.children"
                            :key="child_1.text"
                        >
                            <v-list-item
                                :to="child_1.path"
                                style="margin-left: 15px"
                            >
                                <v-list-item-icon>
                                    <v-icon color="black">{{
                                        child_1.icon
                                    }}</v-icon>
                                </v-list-item-icon>

                                <v-list-item-title
                                    v-text="child_1.text"
                                ></v-list-item-title>
                            </v-list-item>
                        </router-link>
                    </v-list-group>
                </router-link>
            </v-list-group>
        </template>
    </v-list>
</template>
<style media="screen">
a .v-list-item--active {
    color: white !important;
}

.link {
    /* padding: 10px; */
    cursor: pointer;
    text-decoration: none;
    color: black !important;
    display: inline;
}

.listIcon .mdi-chevron-down {
    display: none !important;
}

.listIcon .v-list-group__header__append-icon {
    display: none !important;
}
</style>
<script>
export default {
    data() {
        return {
            rol: 0,
            items: [
                {
                    path: ``,
                    icon: "mdi-home-account",
                    text: "Potenciales",
                    auth: true,
                    roles: [1, 2, 5, 9, 14],
                    hijo: true,
                    children: [
                        {
                            path: "/lista-peticiones",
                            icon: "mdi-home-account",
                            text: "Potenciales",
                            auth: true,
                            roles: [1, 2, 5, 9, 14],
                        },

                        {
                            path: "/lista-presupuesto-potencial",
                            icon: "mdi-cash",
                            text: "Presupuestos",
                            auth: true,
                            roles: [1, 2, 5, 9, 14],
                        },
                        {
                            path: "/lista-seguimiento",
                            icon: "mdi-clock",
                            text: "Seguimiento Potenciales",
                            auth: true,
                            roles: [1, 2, 5, 9],
                        },
                    ],
                },
                {
                    path: ``,
                    icon: "mdi-account-heart",
                    text: "Clientes",
                    auth: true,
                    roles: [1, 2, 5, 9, 14],
                    hijo: true,
                    children: [
                        {
                            path: "/lista-clientes",
                            icon: "mdi-account-heart",
                            text: "Clientes",
                            auth: true,
                            roles: [1, 2, 5, 9, 14],
                        },
                        {
                            path: "/lista-presupuesto-cliente",
                            icon: "mdi-cash",
                            text: "Presupuestos",
                            auth: true,
                            roles: [1, 2, 5, 9, 14],
                        },
                        {
                            path: "/lista-facturas",
                            icon: "mdi-cash",
                            text: "Facturas",
                            auth: true,
                            roles: [1, 2],
                        },
                        {
                            path: "/listado-iva-emitidas",
                            icon: "mdi-file-upload-outline",
                            text: "Listado IVA",
                            auth: true,
                            roles: [1, 2],
                        },
                        {
                            path: "/lista-notas",
                            icon: "mdi-cash-usd",
                            text: "Notas",
                            auth: true,
                            roles: [1, 2],
                        },
                        {
                            path: "/lista-albaranes-venta",
                            icon: "mdi-playlist-check",
                            text: "Albaranes de venta",
                            auth: true,
                            roles: [1, 2],
                        },
                    ],
                },
                /*{
                    path: ``,
                    icon: "mdi-chart-line",
                    text: "Estadísticas",
                    auth: true,
                    roles: [1, 2, 5, 13, 14],
                    hijo: true,
                    children: [
                        {
                            path: "/estadistica-cliente",
                            icon: "mdi-chart-line",
                            text: "Estadísticas",
                            auth: true,
                            roles: [1, 2, 14],
                        },
                        {
                            path: "/controller",
                            icon: "mdi-chart-line",
                            text: "Controller",
                            auth: true,
                            roles: [1, 2, 13, 14],
                        },
                        {
                            path: "/mapa-plan-orden",
                            icon: "mdi-google-maps",
                            text: "Mapa Ventas",
                            auth: true,
                            roles: [1, 2, 5, 14],
                        },
                        {
                            path: "/informe-Anual",
                            icon: "mdi-shape-plus",
                            text: "Informe Anual",
                            auth: true,
                            roles: [1, 2, 14],
                        },
                        {
                            path: "/lista-objetivo-ventas",
                            icon: "mdi-cash",
                            text: "Objetivos Venta",
                            auth: true,
                            roles: [1, 2, 14],
                        },
                        {
                            path: "/informe-general",
                            icon: "mdi-chart-line",
                            text: "Informe General",
                            auth: true,
                            roles: [1, 2, 14],
                        },
                    ],
                },*/
                {
                    path: ``,
                    icon: "mdi-office-building",
                    text: "Empresa",
                    auth: true,
                    roles: [1, 2, 5, 9, 14],
                    hijo: true,
                    children: [
                        {
                            path: "/lista-sociedades",
                            icon: "mdi-account-supervisor-circle",
                            text: "Sociedades",
                            auth: true,
                            roles: [1, 2],
                        },
                        {
                            path: "/lista-usuario",
                            icon: "mdi-account",
                            text: "Empleados",
                            auth: true,
                            roles: [1, 2, 9],
                        },
                        /*{
                            path: "/lista-empleado",
                            icon: "mdi-account",
                            text: "Empleados",
                            auth: true,
                            roles: [1, 2, 14],
                        },*/
                        {
                            path: "/calendario-vacaciones",
                            icon: "mdi-calendar-clock",
                            text: "Vacaciones",
                            auth: true,
                            roles: [1, 2, 14],
                        },
                        {
                            path: "/lista-equipo",
                            icon: "mdi-account-group",
                            text: "Equipos",
                            auth: true,
                            roles: [1, 2, 9],
                        },
                        {
                            path: "/lista-productos",
                            icon: "mdi-shape-plus",
                            text: "Productos",
                            auth: true,
                            roles: [1, 2, 5, 9],
                        },
                        {
                            path: "/lista-productos-compras",
                            icon: "mdi-shape-outline",
                            text: "Productos Compras",
                            auth: true,
                            roles: [1, 2],
                        },
                        {
                            path: "/lista-clientes-conocido",
                            icon: "mdi-account-badge",
                            text: "Clientes Conocidos",
                            auth: true,
                            roles: [1, 2],
                        },
                        /*{
                                path: "/lista-agentes",
                                icon: "mdi-account-tie",
                                text: "Comerciales",
                                auth: true,
                                roles: [1, 2],
                            },*/
                        {
                            path: "/lista-comision-empresa",
                            icon: "mdi-cash-register",
                            text: "Comisiones",
                            auth: true,
                            roles: [1, 2, 14],
                        },
                        {
                            path: "/lista-km",
                            icon: "mdi-ruler",
                            text: "Kilometraje",
                            auth: true,
                            roles: [1, 2, 5, 14],
                        },
                        // Nueva opción Integraciones
                        {
                            path: "/integraciones",
                            icon: "mdi-cog",
                            text: "Integraciones",
                            auth: true,
                            roles: [1], // Solo administrador
                        },
                        {
                            path: "/logs-acceso",
                            icon: "mdi-file-document",
                            text: "Logs de acceso",
                            auth: true,
                            roles: [1], // Solo administrador
                        },
                    ],
                },
                {
                    path: ``,
                    icon: "mdi-truck-fast",
                    text: "Proveedores",
                    auth: true,
                    roles: [1, 2, 9],
                    hijo: true,
                    children: [
                        {
                            path: "/lista-proveedores",
                            icon: "mdi-account",
                            text: "Proveedores",
                            auth: true,
                            roles: [1, 2, 9],
                        },
                        {
                            path: "/lista-pedido-proveedor",
                            icon: "mdi-archive",
                            text: "Pedidos Proveedores",
                            auth: true,
                            roles: [1, 2, 9],
                        },
                        {
                            path: "/lista-albaranes",
                            icon: "mdi-playlist-check",
                            text: "Albaranes Proveedores",
                            auth: true,
                            roles: [1, 2, 9],
                        },
                        {
                            path: "/lista-albaranes-especiales",
                            icon: "mdi-playlist-star",
                            text: "Albaranes Especial",
                            auth: true,
                            roles: [1, 2, 9],
                        },
                        {
                            path: "/lista-facturas-entrante",
                            icon: "mdi-cash",
                            text: "Facturas Entrantes",
                            auth: true,
                            roles: [1, 2],
                        },
                        {
                            path: "/listado-iva-entrantes",
                            icon: "mdi-file-download-outline",
                            text: "Listado IVA",
                            auth: true,
                            roles: [1, 2],
                        },
                        {
                            path: "/lista-pagos",
                            icon: "mdi-cash",
                            text: "Pagos / Abonos ",
                            auth: true,
                            roles: [1, 2],
                        },
                        {
                            path: "/lista-notas-proveedores",
                            icon: "mdi-cash-usd",
                            text: "Notas",
                            auth: true,
                            roles: [1, 2],
                        },
                    ],
                },
                {
                    path: ``,
                    icon: "mdi-screwdriver",
                    text: "Dpto técnico",
                    auth: true,
                    roles: [1, 2, 5, 9, 6, 7, 11, 14],
                    hijo: true,
                    children: [
                        /*{
                            path: "/calendario-plan-orden",
                            icon: "mdi-clock",
                            text: "Planificacion Órdenes",
                            auth: true,
                            roles: [6, 7, 11],
                        },*/
                        {
                            path: "/lista-plan-orden",
                            icon: "mdi-clock",
                            text: "Planificación de obras",
                            auth: true,
                            roles: [1, 9, 6, 7, 11, 14],
                        },
                        {
                            path: "/lista-ordenes",
                            icon: "mdi-cash",
                            text: "Obras",
                            auth: true,
                            roles: [1, 2, 9, 11, 14],
                        },
                        {
                            path: "/seguimiento-orden-trabajo",
                            icon: "mdi-cash",
                            text: "Seguimiento de obras",
                            auth: true,
                            roles: [1, 2, 5, 9, 11, 14],
                        },
                        {
                            path: "/lista-fichajes-ordenes",
                            icon: "mdi-cash",
                            text: "Fichajes de obras",
                            auth: true,
                            roles: [1, 2, 9],
                        },
                    ],
                },
                /*{
                    path: ``,
                    icon: "mdi-currency-eur",
                    text: "Contabilidad",
                    auth: true,
                    roles: [1, 2, 9],
                    hijo: true,
                    children: [
                        {
                            path: "/lista-presupuesto",
                            icon: "mdi-cash",
                            text: "Presupuestos",
                            auth: true,
                            roles: [1, 2],
                        },
                        {
                            path: "/consulta-ordenes",
                            icon: "mdi-book-open-variant",
                            text: "Consulta de órdenes",
                            auth: true,
                            roles: [1, 2],
                        },
                        {
                            path: "/cierre-ordenes",
                            icon: "mdi-chart-line",
                            text: "Cierre de obras",
                            auth: true,
                            roles: [1, 2],
                        },

                        {
                            path: "/lista-libro-diario",
                            icon: "mdi-book-open-variant",
                            text: "Libro Diario",
                            auth: true,
                            roles: [1, 2],
                        },
                        {
                            path: "/reporte-iva",
                            icon: "mdi-book-open-variant",
                            text: "Libro IVA",
                            auth: true,
                            roles: [1, 2],
                        },
                        {
                            path: `/lista-facturacion`,
                            icon: "mdi-cash",
                            text: "Facturación",
                            auth: true,
                            roles: [1, 2],
                        },
                    ],
                },*/
                {
                    path: `/lista-fichajes`,
                    icon: "mdi-account-card-details-outline",
                    text: "Fichajes",
                    auth: true,
                    roles: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14],
                },
            ],
        };
    },
    methods: {
        redirect(path, a) {
            if (a) {
                this.$router.push({
                    path: path,
                });
            } else {
                this.$router.push(path);
            }
        },
    },
    created() {
        this.rol = parseInt(localStorage.getItem("role"));
        //console.log(this.rol);
        let items = [];
        this.items.forEach((element) => {
            let correcto = false;
            if (element.roles != null) {
                for (let i = 0; i < element.roles.length; i++) {
                    if (element.roles[i] == this.rol) {
                        let elemento = JSON.parse(JSON.stringify(element));
                        elemento.children = [];
                        if (element.children != null) {
                            element.children.forEach((child) => {
                                if (child.roles.includes(this.rol)) {
                                    elemento.children.push(child);
                                }
                            });
                        }
                        items.push(elemento);
                        break;
                    }
                }
            } else {
                items.push(element);
            }
        });
        this.items = items;
    },
};
</script>
<style media="screen">
.v-list-item--active {
    background-color: #59fee2 !important;
}
</style>
